<template>
    <module-box
        class="md-featured-area-near standard"
        mobileBtmSpacing="30"
        :class="{ mobile: mobile }"
        v-if="showAreaNear && allNears.length"
    >
        <h2 class="area-title">{{ areaTitle }}</h2>
        <div class="near-list">
            <a
                class="near-item"
                v-for="(nbr, index) in allNears"
                :key="index"
                rel="noopener noreferrer"
                :href="handleLink(nbr)"
                target="_blank"
            >{{ nbr }}</a
            >
        </div>
        <div class="control-show" @click="showMore" v-if="showShowMore">
            <span class="more-less">{{
                $t('showMore')
            }}</span>
        </div>
    </module-box>
</template>
<script>
import { defineComponent } from 'vue';
import common from '../';
export default defineComponent({
    mixins: [common]
});
</script>
<style lang="scss">
.md-featured-area-near.standard {
    .area-title {
        text-transform: uppercase;
        font-size: 24px;
        color: #191919;
        font-family: var(--mg-title-font);
    }
    .near-list {
        margin-top: 30px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-row-gap: 8px;
        overflow: hidden;
        .near-item {
            color: var(--color-title);
            font-family: var(--font-normal);
            font-size: 14px;
            width: fit-content;
            &:hover {
                color: var(--color-theme);
                text-decoration: underline;
            }
        }
    }
    .control-show {
        text-align: center;
        margin-top: 20px;
        .more-less {
            color: var(--color-theme);
            font-size: 14px;
            font-family: var(--font-normal);
            cursor: pointer;
        }
    }
    &.mobile {
        .area-title {
            font-size: 16px;
        }
        .near-list {
            grid-template-columns: 1fr;
            margin-top:15px;
            .near-item {
                font-size: 14px;
                line-height: 17px;
                &:nth-child(5n + 1) {
                    margin-top: 12px;
                }
                &:nth-child(1){
                    margin-top: 0px;
                }
            }
        }
        .control-show {
            text-align: left;
            margin-top: 20px;
        }
    }
}
</style>
